import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// One subtag pair; used for the host-forced (embedded) and device (browser)
// sources. Either subtag may be absent when the source carries only one.
export interface LocaleParts {
  language?: string
  region?: string
}

// One field per real locale signal. The resolved format locale is derived from
// these by selectLocale, never stored here. The user's saved preference is not a
// field here — it lives on the session user (selectUserLanguage/selectUserRegion)
// and selectLocale reads it from there directly.
export interface LocaleSliceState {
  // Embedded host suggests a full locale (applyHostLocale)
  embedded: LocaleParts | undefined
  // Device signals (navigator/Intl), set by LocaleHandler post-mount only — empty
  // on the server and first client render, so it can't cause a hydration mismatch.
  browser: LocaleParts
}

export const localeSliceInitialState: LocaleSliceState = {
  embedded: undefined,
  browser: {},
}

const localeSlice = createSlice({
  name: "localeSlice",
  initialState: localeSliceInitialState,
  reducers: {
    setEmbeddedLocale: (
      state,
      action: PayloadAction<LocaleParts | undefined>
    ) => {
      state.embedded = action.payload
    },
    setBrowserLocale: (state, action: PayloadAction<LocaleParts>) => {
      state.browser = action.payload
    },
  },
})

export const { setEmbeddedLocale, setBrowserLocale } = localeSlice.actions

export default localeSlice
